import { gql } from '@apollo/client';
import eventBidFragment from './eventBidFragment';

const BID_ON_EVENT = gql`
  mutation BidOnEvent($eventId: Int!) {
    bidOnEvent(eventId: $eventId) {
      ...EventBidFields
    }
  }
  ${eventBidFragment}
`;

export default BID_ON_EVENT;
